import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IBusinessType extends IBaseEntity {
    id?: number;
    description?: string;
    captureDebriefInformation?: string;
    palletThresholdMin?: boolean;
    palletThresholdMax?: number;
    defaultNominalCodeId?: number;
    defaultNominalCodeCode?: string;
    subcontractedNominalCodeId?: number;
    subcontractedNominalCodeCode?: string;
    subcontractedSelfBillNominalCodeId?: number;
    subcontractedSelfBillNominalCodeCode?: string;
    showCreateJob?: boolean;
    createJobCreated?: boolean;
    isPalletNetwork?: boolean;
    excludeFromConsortiumMemberFileExport?: boolean;
    MWFBypassCleanClausedScreen?: boolean;
    MwfBypassCommentsScreen?: boolean;
    palletNetworkExportDepotCode?: string;
    MWFConfirmCallIn?: boolean;
    useVehicleNominalCode?: boolean;
    isDeleted?: boolean;
    createQuoteByDefault?: boolean;
    enableTrailerSelection?: boolean;
}

export class BusinessType extends BaseEntity implements IBusinessType {
    public id?: number;
    public description?: string;
    public captureDebriefInformation?: string;
    public palletThresholdMin?: boolean;
    public palletThresholdMax?: number;
    public defaultNominalCodeId?: number;
    public defaultNominalCodeCode?: string;
    public subcontractedNominalCodeId?: number;
    public subcontractedNominalCodeCode?: string;
    public subcontractedSelfBillNominalCodeId?: number;
    public subcontractedSelfBillNominalCodeCode?: string;
    public showCreateJob?: boolean;
    public createJobCreated?: boolean;
    public isPalletNetwork?: boolean;
    public excludeFromConsortiumMemberFileExport?: boolean;
    public MWFBypassCleanClausedScreen?: boolean;
    public MwfBypassCommentsScreen?: boolean;
    public palletNetworkExportDepotCode?: string;
    public MWFConfirmCallIn?: boolean;
    public useVehicleNominalCode?: boolean;
    public isDeleted?: boolean;
    public createQuoteByDefault?: boolean;
    public enableTrailerSelection?: boolean;

    constructor(businessType?: any) {
        super();
        if (businessType) {
            this.id = businessType.id;
            this.description = businessType.description;
            this.captureDebriefInformation = businessType.captureDebriefInformation;
            this.palletThresholdMin = businessType.palletThresholdMin;
            this.palletThresholdMax = businessType.palletThresholdMax;
            this.defaultNominalCodeId = businessType.defaultNominalCodeId;
            this.defaultNominalCodeCode = businessType.defaultNominalCodeCode;
            this.subcontractedNominalCodeId = businessType.subcontractedNominalCodeId;
            this.subcontractedNominalCodeCode = businessType.subcontractedNominalCodeCode;
            this.subcontractedSelfBillNominalCodeId = businessType.subcontractedSelfBillNominalCodeId;
            this.subcontractedSelfBillNominalCodeCode = businessType.subcontractedSelfBillNominalCodeCode;
            this.showCreateJob = businessType.showCreateJob;
            this.createJobCreated = businessType.createJobCreated;
            this.isPalletNetwork = businessType.isPalletNetwork;
            this.excludeFromConsortiumMemberFileExport = businessType.excludeFromConsortiumMemberFileExport;
            this.MWFBypassCleanClausedScreen = businessType.MWFBypassCleanClausedScreen;
            this.MwfBypassCommentsScreen = businessType.MwfBypassCommentsScreen;
            this.palletNetworkExportDepotCode = businessType.palletNetworkExportDepotCode;
            this.MWFConfirmCallIn = businessType.MWFConfirmCallIn;
            this.useVehicleNominalCode = businessType.useVehicleNominalCode;
            this.isDeleted = businessType.isDeleted;
            this.createQuoteByDefault = businessType.createQuoteByDefault;
            this.enableTrailerSelection = businessType.enableTrailerSelection;
        }
    }

    get discriminator(): any {
        return this.description;
    }

    clone(): BusinessType {
        return new BusinessType(this);
    }
}
